import { useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_create } from '@zg-rentals/ts-rental-manager-api-client-react-query';

import { usePropertyEditMutation } from './usePropertyEditMutation';
import { FEED_OVERRIDES_TAG } from '../constants/FeedOverrideConstants';

import type { UserPropertyFeedFloorPlanCreateRequestDto } from '@zg-rentals/ts-rental-manager-api-client';

export type CreateFeedFloorPlanInput = Omit<UserPropertyFeedFloorPlanCreateRequestDto, 'listingAlias'>;

/**
 * Feed listings can't use the manual floor-plan create endpoint; a feed floor plan is written as a
 * zramModel feed override instead. The caller supplies the field values and the listingAlias is
 * added from the route.
 */
export const useCreateFeedFloorPlan = (listingAlias: string) => {
  const { mutateAsync, isPending } = usePropertyEditMutation({
    mutationHook: useRentalManagerUserPropertyFeedFloorPlanWebApiHandler_create,
    successToastMessage: 'Floor plan created',
    meta: {
      invalidates: [FEED_OVERRIDES_TAG, 'mf-costsAndFees'],
      context: { api: 'RentalManagerUserPropertyFeedFloorPlanWebApiHandler_create', details: { listingAlias } },
    },
  });

  const createFeedFloorPlan = (input: CreateFeedFloorPlanInput) =>
    mutateAsync({ postData: { listingAlias, ...input } });

  return { createFeedFloorPlan, isPending };
};
